import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { CommonModule, NgOptimizedImage } from '@angular/common';
import { GoogleAnalyticsService } from './google-analytics.service';

import { DownloadComponent } from './download/download.component';
import { PaeViewComponent } from './pae-view/pae-view.component';
import { EntryStatusComponent } from './entry-status/entry-status.component';
import { ClusterTableComponent } from './cluster-table/cluster-table.component';
import { HeatmapComponent } from './heatmap/heatmap.component';
import { FileDownloadComponent } from './file-download/file-download.component';
import { NewsPopupComponent } from './news-popup/news-popup.component';
import { StructureViewerComponent } from './structure-viewer/structure-viewer.component';
import { FoldseekTableComponent } from './foldseek-table/foldseek-table.component';
import { DescriptionDirective } from './foldseek-table/directives/description.directive';
import { ResidueRangeDirective } from './foldseek-table/directives/residue-range.directive';
import { TedDomainsComponent } from './ted-domains/ted-domains.component';
import { PopupComponent } from './popup/popup.component';

import { SharedModule } from './shared.module';
import { NgMaterialModule } from './ngmaterial.module';
import { EntryRoutingModule } from './entry-routing.module';
import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';
import { ENTRY_STORE_STATE_KEY, entryReducer } from './state/entry.reducer';
import { EntryEffects } from './state/entry.effect';
import { EntryPageHeaderComponent } from './entry/entry-page-header/entry-page-header.component';
import { EntryPageFooterComponent } from './entry/entry-page-footer/entry-page-footer.component';
import { NgxSkeletonLoaderModule } from 'ngx-skeleton-loader';
import { SummaryTabComponent } from './entry/summary-tab/summary-tab.component';
import { SimilarStructuresTabComponent } from './entry/similar-structures-tab/similar-structures-tab.component';
import { HelpIconWithTooltipComponent } from './help-icon-with-tooltip/help-icon-with-tooltip.component';
import { LegendsPanelComponent } from './entry/legends-panel/legends-panel.component';
import { DomainsTabComponent } from './entry/domains-tab/domains-tab.component';
import { InteractiveLeftTableComponent } from './entry/interactive-left-table/interactive-left-table.component';
import { LinearLegendsComponent } from './entry/linear-legends/linear-legends.component';
import { EntryDropdownComponent } from './entry/entry-dropdown/entry-dropdown.component';
import { AnnotationsTabComponent } from './entry/annotations-tab/annotations-tab.component';
import { DownloadDropdownComponent } from './entry/download-dropdown/download-dropdown.component';
import { OverviewMobileComponent } from './entry/mobile/overview-mobile/overview-mobile.component';
import { MolstarGalleryComponent } from './entry/mobile/molstar-gallery/molstar-gallery.component';
import { EntryComponent } from './entry/entry.component';
import { MolstarComponent } from './entry/mobile/molstar/molstar.component';
import { ModelConfidenceComponent } from './entry/mobile/model-confidence/model-confidence.component';
import { DomainsComponent } from './entry/mobile/domains/domains.component';
import { AnnotationsComponent } from './entry/mobile/annotations/annotations.component';
import { SimilarProteinsComponent } from './entry/mobile/similar-proteins/similar-proteins.component';
import { MbFoldseekTableComponent } from './entry/mobile/mb-foldseek-table/mb-foldseek-table.component';
import { AfdbTabComponent } from './foldseek-table/afdb-tab/afdb-tab.component';
import { PdbTabComponent } from './foldseek-table/pdb-tab/pdb-tab.component';
import { AllbacteriaTabComponent } from './foldseek-table/allbacteria-tab/allbacteria-tab.component';
import { BfvdTabComponent } from './foldseek-table/bfvd-tab/bfvd-tab.component';
import { NtdxTabComponent } from './foldseek-table/ntdx-tab/ntdx-tab.component';
import { AddAnnotationsComponent } from './heatmap/add-annotations/add-annotations.component';
import { ZoomAnnotationsComponent } from './heatmap/zoom-annotations/zoom-annotations.component';
import { ProtvistaWrapperComponent } from './new-protvista/pv-angular-wrapper/pv-angular-wrapper.component';
import { EditAnnotationsComponent } from './heatmap/edit-annotations/edit-annotations.component';

@NgModule({
  declarations: [
    EntryComponent,
    DownloadComponent,
    PaeViewComponent,
    ClusterTableComponent,
    HeatmapComponent,
    NewsPopupComponent,
    StructureViewerComponent,
    FoldseekTableComponent,
    AfdbTabComponent,
    PdbTabComponent,
    AllbacteriaTabComponent,
    BfvdTabComponent,
    NtdxTabComponent,
    DescriptionDirective,
    ResidueRangeDirective,
    TedDomainsComponent,
    PopupComponent,
    EntryPageHeaderComponent,
    EntryPageFooterComponent,
    SummaryTabComponent,
    HelpIconWithTooltipComponent,
    LegendsPanelComponent,
    SimilarStructuresTabComponent,
    DomainsTabComponent,
    InteractiveLeftTableComponent,
    LinearLegendsComponent,
    EntryDropdownComponent,
    AnnotationsTabComponent,
    DownloadDropdownComponent,
    OverviewMobileComponent,
    MolstarGalleryComponent,
    MolstarComponent,
    ModelConfidenceComponent,
    DomainsComponent,
    AnnotationsComponent,
    SimilarProteinsComponent,
    MbFoldseekTableComponent,
    AddAnnotationsComponent,
    ZoomAnnotationsComponent,
    ProtvistaWrapperComponent,
    EditAnnotationsComponent
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  imports: [
    CommonModule,
    NgOptimizedImage,
    FormsModule,
    SharedModule,
    NgMaterialModule,
    EntryRoutingModule,
    NgxSkeletonLoaderModule,
    StoreModule.forFeature(ENTRY_STORE_STATE_KEY, entryReducer),
    EffectsModule.forFeature([EntryEffects]),
  ],
  providers: [GoogleAnalyticsService],
})
export class EntryModule {}
